<div class="fc-signup-verified-email">
    <div class="fc-signup-verified-email-frame">
        <div class="fc-signup-verified-email-frame-body">
            <div class="fc-signup-verified-email-frame-body-header">
                {{ 'SIGNUP.VERIFIED_EMAIL.HEADER' | translate }}
            </div>
            <div class="fc-signup-verified-email-frame-body-description">
                {{ 'SIGNUP.VERIFIED_EMAIL.DESCRIPTION' | translate }}
            </div>

            <div class="fc-signup-verified-email-frame-body-button">
                <button
                    fcp-filled-button
                    data-e2e-hook="signup-verified-email-resend-button"
                    (click)="continueSignup()"
                >
                    {{ 'SIGNUP.VERIFIED_EMAIL.BUTTON.LABEL' | translate }} <i class="fal fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>
